import { Component } from '@angular/core';
import { SettingsService } from './services/settings.js.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'peopletalent';

  // tslint:disable-next-line: variable-name
  constructor(public _ajustes: SettingsService) {
  }
}
